import { Button } from '@wot/components';
import { CLOSE_ICON } from '../../assets/icons';
import { useAppDispatch, useAppSelector } from '../../hooks/useRedux';
import { acceptProfileAgreement } from '../../reducers/profileSetupSlice';
import { format } from 'date-fns/esm';
import { parseISO } from 'date-fns';
import BottomSheet from '../../components/Bottomsheet';

export function AcceptLicenseAgreement({ setAgreementVisibility }: any) {
  const { request } = useAppSelector((state) => state.profileSetupSlice);
  const dispatch = useAppDispatch();
  //@ts-ignore
  const { agreement } = request;
 const onSubmit = async () => {
    if (request?.agreement?.status === 'pending') {
      await dispatch(acceptProfileAgreement()).then(() => {
        window.location.reload();
      });
    }
  };


  return (
    <BottomSheet>
      <>
        <div className="w-full flex justify-end py-10 px-4 md:px-10">
          <img
            src={CLOSE_ICON}
            alt="close"
            className="h-4 cursor-pointer"
            onClick={() => setAgreementVisibility(false)}
          />
        </div>
        <div className="w-full flex flex-col h-[550px] items-center px-4 md:px-20 pb-20 overflow-y-scroll">
          <h3 className="text-lg font-bold text-center pb-4 md:pb-10">Agreement</h3>
          <p className='text-sm py-4'>Expries on {agreement && format(parseISO(agreement && agreement?.offerExpiryDate), 'dd/mm/yyyy')}</p>
          <div className="w-[90%] md:w-[75%] w-max-[900px] flex flex-col gap-4 justify-start leading-8">
            {request?.agreement?.document.map((item, index) => (
              <div key={index} className="flex flex-col gap-4">
                {item.title && <h1>{item.title}</h1>}
                {item.contents && (
                  <div className="flex flex-col gap-2">
                    {item.contents.map((item, index) => (
                      <p key={index} className="text-sm">
                        {item}
                      </p>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        <hr />
        <div className="w-full flex justify-center">
          <div className="w-full max-w-[164px] py-3">
            <Button block text="Accept" onClick={() => onSubmit()} />
          </div>
        </div>
      </>
    </BottomSheet>
  );
}
